<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="mintalMesPrdSmeltingSlagIronResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      with-custom-row-actions-first-column
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <b-button
                                        variant="outline-primary"
                                        size="sm"
                                        @click="openCreateDialog()"
                                    >
                                        创建出炉记录
                                    </b-button>
                                    <em-button
                                        type="process"
                                        class="btn btn-outline-primary btn-sm"
                                        custom-label="创建质检任务"
                                        :disabled="$_notCheckedOne"
                                        :busy="createInspect.loading"
                                        @click="$refs.inspectTaskSelect.showModal()">
                                    </em-button>
                                </template>
                                <template slot="customRowActionsFirstColumn" slot-scope="scope">
                                    <b-button-group>
                                        <em-button
                                            type="process"
                                            custom-icon="fa fa-eye"
                                            class="btn btn-outline-primary btn-sm"
                                            custom-label="查看样品检验"
                                            @click="viewInspectSamples(scope.row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog title="创建出炉记录" :visible.sync="createDialogVisible" :close-on-click-modal='false' append-to-body
                   @close='clearCreateForm'>
            <el-form :model="createForm" ref="createForm" label-width="auto" width="30%" :inline="true" :rules="rules">
                <el-form-item label="车间" prop="locationId">
                    <el-select v-model="createForm.locationId" placeholder="请选择车间">
                        <el-option v-for="location in locationOptions" :key="location.id" :label="location.text" :value="location.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="冶炼炉" prop="furnaceId">
                    <el-select v-model="createForm.furnaceId" placeholder="请选择炉号">
                        <el-option v-for="furnace in furnaceOptions" :key="furnace.id" :label="furnace.text" :value="furnace.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开始时间" prop="startTime">
                    <el-date-picker v-model="createForm.startTime" type="datetime" placeholder="选择日期时间"
                                    value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间" prop="endTime">
                    <el-date-picker v-model="createForm.endTime" type="datetime" placeholder="选择日期时间"
                                    value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="createDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="createBasicRecords()">创建</el-button>
            </div>
        </el-dialog>

        <ReBModal ref="inspectTaskSelect"
                  header="创建质检单"
                  @ok="createInspectTask"
                  @show="checkInspectExist">
            <div class="d-flex flex-column">
                <key-value-cell :value="createInspect.exist">已存在的检验：</key-value-cell>
                <b-form-checkbox
                    v-model="createInspect.ts"
                    :value="true" :unchecked-value="false">
                    铁水检验
                </b-form-checkbox>
                <b-form-checkbox
                    v-model="createInspect.tz"
                    :value="true" :unchecked-value="false">
                    铁渣检验
                </b-form-checkbox>
            </div>
        </ReBModal>
    </div>
</template>
<script>
// Author Lin
// Date 2021-10-09 10:13:03

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import KeyValueCell from "@/views/sithMes/prd/PrdOperationExcute/cells/KeyValueCell";

export default {
    name: "mintalMesPrdSmeltingSlagIronListView",
    components: {KeyValueCell, ReBModal},
    mixins: [emCommonListMixin, emCommonApiMixin, emCommonGotoMixin, emTableCheckedMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            createDialogVisible: false,
            createForm: {
                locationId: '',
                furnaceId: '',
                startTime: '',
                endTime: ''
            },
            rules: {
                locationId: [{required: true, message: '请输入车间ID'}],
                furnaceId: [{required: true, message: '请输入冶炼炉ID'}],
                startTime: [{required: true, message: '请输入开始时间'}],
                endTime: [{required: true, message: '请输入结束时间'}],
            },
            createInspect: {
                ts: false,
                tz: false,
                loading: false,
                exist: ""
            },
            locationOptions: [],
            furnaceOptions: [],
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    methods: {
        openCreateDialog() {
            this.createDialogVisible = true;
        },
        clearCreateForm() {
            this.createForm.locationId = '';
            this.createForm.furnaceId = '';
            this.createForm.startTime = '';
            this.createForm.endTime = '';
            this.$refs["createForm"].resetFields();
        },
        createBasicRecords() {
            let self = this;
            self.$refs["createForm"].validate(valid => {
                if (valid) {
                    let url = `${this.$_emApiMixin_entityBaseApi("mintalMesPrdSmeltingSlagIron")}/createBasicRecords`;
                    self.$_emApiMixin_post(url, self.createForm)
                        .then((request) => {
                            if (request.status === 200) {
                                self.$message({
                                    message: "创建成功",
                                    type: "success",
                                });
                                self.$refs["emListFilter"].doQuery()
                            } else {
                                self.$message({
                                    message: "创建失败",
                                    type: "error",
                                });
                            }
                        }).finally(() => {
                        this.createDialogVisible = false;
                    })
                } else {
                    self.$message({
                        message: "数据不完整",
                        type: "error",
                    });
                    return;
                }
            })
        },
        viewInspectSamples(row) {
            this.$store.commit('routeStore/setObject', {inspectObject: row.id, inspectTypeList: [4, 5]});
            this.$_emGotoMixin_gotoHolderList('mintalMesQualityProductionSample'
                , {}, {}, false, {isObject: true});
        },
        createInspectTask() {
            if (!this.$_notCheckedOne) {
                this.createInspect.loading = true;
                this.$store.dispatch('api/post', {
                    url: `${process.env.VUE_APP_MINTALMES_QUALITY_URL}/mintalMesQualityProductionProject/createTask/slagIron?id=${this.selectIds}&TS=${this.createInspect.ts}&TZ=${this.createInspect.tz}`,
                    data: {}
                }).then(() => {
                    this.$message.success("创建成功");
                }).finally(() => this.createInspect.loading = false);
            }
        },
        checkInspectExist() {
            if (!this.$_notCheckedOne && this.$refs.inspectTaskSelect) {
                this.$refs.inspectTaskSelect.changeLoading(true);
                this.$store.dispatch('api/get', {
                    url: `${process.env.VUE_APP_MINTALMES_QUALITY_URL}/mintalMesQualityProductionProject/checkExist/slagIron?id=${this.selectIds}`
                }).then(response => {
                    this.createInspect.exist = response;
                }).finally(() => {
                    if (this.$refs.inspectTaskSelect) {
                        this.$refs.inspectTaskSelect.changeLoading(false);
                    }
                });
            }
        },
        getSmeltingLocation() {
            let self = this;
            let url = `${this.$_emApiMixin_entityBaseApi("mintalMesPrdSmeltingSlagIron")}/getSmeltingLocation`;
            self.$_emApiMixin_get(url, false).then(response => {
                self.locationOptions = response.map(loc => {
                    return {id:loc.id, text:loc.name}
                })
            })
        },
        getFurnace() {
            this.$_emApiMixin_findByFilter("mintalMesMstFurnace", {})
                .then(data => {
                    this.furnaceOptions = data.map(m => {
                        return {id: m.id, text: m.furnaceName}
                    })
                })
        }
    },
    mounted() {
        this.getSmeltingLocation();
        this.getFurnace();
    }
};
</script>

<style scoped>
.d-flex >>> .custom-checkbox label {
    width: 100% !important;
}
</style>
